.overlay {
  position: fixed;
  inset: 0;
  z-index: 400;
  background: var(--scrim);
  border: none;
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 401;
  width: 720px;
  max-width: 95vw;
  height: 84vh;
  display: flex;
  flex-direction: column;
  background: var(--card-bg);
  border-radius: var(--r-lg);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}
.title {
  font-size: 15px;
  font-weight: 700;
}
.subtitle {
  font-size: 13px;
  color: var(--text2);
  margin-top: 2px;
}
.spacer {
  flex: 1;
}
.close {
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  color: var(--text2);
  cursor: pointer;
}
.close:hover {
  color: var(--text);
}

.tabs {
  display: flex;
  gap: 2px;
  padding: 0 20px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  overflow-x: auto;
}
.tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  font-size: 12.5px;
  white-space: nowrap;
  color: var(--text2);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.tab:hover {
  color: var(--text);
}
.tabActive {
  color: var(--blue);
  border-bottom-color: var(--blue);
  font-weight: 600;
}
.badge {
  min-width: 18px;
  padding: 0 6px;
  font-size: 12.5px;
  line-height: 17px;
  text-align: center;
  color: var(--text2);
  background: var(--table-even);
  border-radius: var(--r-pill);
}

.body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}
.intro {
  margin: 0 0 12px;
  font-size: 12.5px;
  line-height: 1.55;
  color: var(--text2);
}

.tableWrap {
  max-height: 260px;
  overflow: auto;
  margin-bottom: 12px;
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}
.table {
  width: 100%;
  border-collapse: collapse;
}
.table th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 7px 11px;
  font-size: 12.5px;
  font-weight: 600;
  text-align: left;
  color: var(--text2);
  background: var(--card-bg);
  border-bottom: 1px solid var(--border);
}
.table td {
  padding: 6px 11px;
  font-size: 12.5px;
  border-bottom: 1px solid var(--border);
}

/* Перезапись и перенос — изменение чужих данных; полоса слева,
   чтобы такие строки не терялись среди обычных */
.rowWarn {
  background: var(--warn-bg);
  box-shadow: inset 3px 0 0 var(--warn);
}

.mono {
  font-family: var(--mono);
  font-size: 13px;
}
.muted {
  color: var(--slate);
  font-style: italic;
}

.ok,
.warning,
.error,
.note {
  margin-bottom: 12px;
  padding: 10px 12px;
  font-size: 12.5px;
  line-height: 1.5;
  border-radius: var(--r-sm);
}
.ok {
  color: var(--ok);
  background: var(--ok-bg);
}
.warning {
  color: var(--warn);
  background: var(--warn-bg);
}
.error {
  color: var(--err);
  background: var(--err-bg);
}
.note {
  color: var(--text2);
  background: var(--table-even);
}
.list {
  margin: 6px 0 0 18px;
  padding: 0;
}

.checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 12.5px;
  cursor: pointer;
}

.footer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
  flex-wrap: wrap;
}
.button {
  padding: 8px 14px;
  font-size: 12.5px;
  color: var(--text2);
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  cursor: pointer;
}
.button:hover {
  border-color: var(--blue);
  color: var(--blue);
}
.button:disabled {
  opacity: 0.5;
  cursor: default;
}
.primary {
  color: #fff;
  background: var(--blue);
  border-color: var(--blue);
  font-weight: 600;
}
.primary:hover {
  color: #fff;
  background: var(--blue-dark);
}

@media (max-width: 640px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
    top: 0;
    left: 0;
    transform: none;
  }
}

/* ── Запрос на отправку ── */
.include {
  padding: 8px 10px;
  background: var(--table-even);
  border-radius: var(--r-sm);
  font-weight: 600;
}
.link {
  padding: 0;
  font: inherit;
  color: var(--blue);
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
}
.footer {
  flex-direction: column;
  align-items: stretch;
}
.footerRow {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.comment {
  width: 100%;
  padding: 8px 10px;
  font: inherit;
  font-size: 12.5px;
  color: var(--text);
  resize: vertical;
  background: var(--input-bg, var(--card-bg));
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
}
.comment:focus {
  border-color: var(--blue);
  outline: none;
}
.summary {
  font-size: 13px;
  color: var(--text2);
}
